module.exports = __webpack_public_path__ + "img/leaf_3.8ae22d63.png";